import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import axios from 'axios';
import qs from 'qs';
import * as constants from '../../util/constants';
import helpers from '../../util/helpers';

const VenuesSkeleton = () => {
  return (
    <Fragment>
      {
        Array.from(Array(8).keys()).map((i) => {
          return (
            <div key={i} className="col-span-1">
              <div className="venue-item skeleton">
                <div className="venue-item-image-container">
                  <div className="venue-item-image-wrapper skeleton-shine" />
                </div>
                <div className="venue-item-details">
                  <div className="venue-mobile-stats-1 skeleton-shine" />
                  <div className="venue-item-title skeleton-shine" />
                  <div className="venue-mobile-stats-2 skeleton-shine" />
                  <div className="venue-desktop-stats skeleton-shine" />
                  <div className="venue-item-description skeleton-shine" />
                  <div className="venue-item-price skeleton-shine" />
                </div>
              </div>
            </div>
          );
        })
      }
    </Fragment>
  );
};

class AppVenues extends Component {
  constructor(props) {
    super(props);

    // Initial state
    this.initialState = {
      loading: true,
      venuesCount: 0,
      allVenues: [],
      loadMoreLoading: false,
      loadedAll: false,
    };

    const {
      venueType,
    } = this.props;

    // Assign first state
    this.state = Object.assign({}, this.initialState);

    this.type = '';

    const type = helpers.getParameterByName('type');
    if (type != null && type.length) {
      this.type = venueType === type ? type : venueType;

      const params = helpers.getParameters();
      params['type'] = this.type;

      // Push params to url
      helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

      $(document).trigger(constants.EVENT_VENUES_TYPE_FILTER_CHANGED, [this.type]);
    } else {
      this.type = venueType;
    }

    // Bind "this"
    this.handleLoadMoreVenuesOnWindowEvents = this.handleLoadMoreVenuesOnWindowEvents.bind(this);
    this.loadVenues = this.loadVenues.bind(this);
    this.loadMoreVenues = this.loadMoreVenues.bind(this);

    // Cancel token source
    this.source = axios.CancelToken.source();
  }

  componentDidMount() {
    this.loadVenues();

    $(document).on(constants.EVENT_VENUES_TYPE_FILTER_CHANGED, (e, type) => {
      if (this.type !== type) {
        this.type = type;
        this.loadVenues();
      }
    });

    helpers.onWindowEvents(this.handleLoadMoreVenuesOnWindowEvents, 0, 1, 1, 1);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.loading ||
      (prevState.loading && !this.state.loading)
    ) {
      const venuesCount = $('.venues-results-block .venues-count');
      if (venuesCount.length) {
        if (this.state.loading) {
          venuesCount.text('');
        } else {
          venuesCount.text(`${this.state.venuesCount} ${this.state.venuesCount > 1 ? 'Venues' : 'Venue'}`);
        }
      }
    }
  }

  handleLoadMoreVenuesOnWindowEvents() {
    const {
      loading,
      loadMoreLoading,
      loadedAll,
    } = this.state;

    if (!loading && !loadMoreLoading && !loadedAll) {
      const triggerElement = $('#load-more-venues-trigger');
      const elementTop = triggerElement.offset().top;
      const elementBottom = elementTop + triggerElement.outerHeight();
      const viewHeight = $(window).height();
      const scrollTop = $(document).scrollTop();
      const scrollBottom = scrollTop + viewHeight;

      if (elementBottom > scrollTop && elementTop < scrollBottom) {
        this.loadMoreVenues();
      }
    }
  }

  loadVenues() {
    // Reset state
    this.setState(this.initialState);

    const {
      displayType,
      eventType,
      venueIds,
      imageType,
    } = this.props;

    // Params
    const data = {
      'action': constants.ACTION_GET_VENUES,
      'display_type': displayType,
      'event_type': eventType,
      'venue_ids': venueIds,
      'image_type': imageType,
      'offset': 0,
    };

    // Send request
    axios.post(window.IndCollStandalone['ajaxUrl'], qs.stringify(data), {
      cancelToken: this.source.token,
    }).then((axiosResponse) => {
      if (200 === axiosResponse.status) {
        const response = axiosResponse.data;

        if (response.success) {
          const venuesCount = response.data['venues_count'];
          const venues = response.data['venues'];

          if (venuesCount > 0) {
            this.setState({
              loading: false,
              venuesCount,
              allVenues: [...venues],
              loadMoreLoading: false,
              loadedAll: parseInt(venuesCount) === venues.length,
            });
          } else {
            this.setState({
              loading: false,
              venuesCount: 0,
              allVenues: [],
              loadMoreLoading: false,
              loadedAll: true,
            });
          }
        } else {
          this.setState({
            loading: false,
            venuesCount: 0,
            allVenues: [],
            loadMoreLoading: false,
            loadedAll: true,
          });
        }
      }
    }).catch((error) => {
      console.log(error);
    });
  }

  loadMoreVenues() {
    const {
      displayType,
      eventType,
      venueIds,
      imageType,
    } = this.props;
    const {
      allVenues,
      loadedAll,
    } = this.state;

    if (!loadedAll) {
      this.setState({
        loading: false,
        loadMoreLoading: true,
      });

      // Params
      const data = {
        'action': constants.ACTION_GET_VENUES,
        'display_type': displayType,
        'event_type': eventType,
        'venue_ids': venueIds,
        'image_type': imageType,
        'offset': allVenues.length,
      };

      // Send request
      axios.post(window.IndCollStandalone['ajaxUrl'], qs.stringify(data), {
        cancelToken: this.source.token,
      }).then((axiosResponse) => {
        if (200 === axiosResponse.status) {
          const response = axiosResponse.data;

          if (response.success) {
            const venuesCount = response.data['venues_count'];
            const venues = [
              ...allVenues,
              ...response.data['venues'],
            ];

            if (venuesCount > 0) {
              this.setState({
                loading: false,
                allVenues: [...venues],
                loadMoreLoading: false,
                loadedAll: parseInt(venuesCount) === venues.length,
              });
            } else {
              this.setState({
                loading: false,
                loadMoreLoading: false,
                loadedAll: true,
              });
            }
          } else {
            this.setState({
              loading: false,
              loadMoreLoading: false,
              loadedAll: true,
            });
          }
        }
      }).catch((error) => {
        console.log(error);
      });
    }
  }

  render() {
    const {
      loading,
      allVenues,
      loadMoreLoading,
    } = this.state;

    return (
      <div className="grid grid-cols-1 gap-6">
        {
          (!loading && allVenues.length > 0) && (
            this.type === 'list' ? (
              <Fragment>
                {
                  allVenues.map((venue, i) => {
                    return (
                      <div key={i} className="col-span-1">
                        <a href={venue['link']} className="venue-item">
                          <div className="venue-item-image-container">
                            <div className="venue-item-image-wrapper">
                              {
                                venue['image'].length > 0 && (
                                  <img src={venue['image']}
                                      className="venue-item-image"
                                      loading="lazy"
                                      decoding="async"
                                      alt=""
                                  />
                                )
                              }
                            </div>
                          </div>
                          <div className="venue-item-details">
                            {
                              ( venue['classroom_capacity'].length > 0 || venue['cocktail_capacity'].length > 0 ) && (
                                <div className="venue-mobile-stats-1">
                                  {
                                    venue['classroom_capacity'].length > 0 && (
                                      <div className="stat-item">
                                        <div className="stat-item-icon" dangerouslySetInnerHTML={{__html: window.IndCollStandalone['assets']['chair']}} />
                                        <div className="stat-item-value">
                                          {venue['classroom_capacity']}
                                        </div>
                                      </div>
                                    )
                                  }
                                  {
                                    venue['cocktail_capacity'].length > 0 && (
                                      <div className="stat-item">
                                        <div className="stat-item-icon" dangerouslySetInnerHTML={{__html: window.IndCollStandalone['assets']['man']}} />
                                        <div className="stat-item-value">
                                          {venue['cocktail_capacity']}
                                        </div>
                                      </div>
                                    )
                                  }
                                </div>
                              )
                            }
                            {
                              venue['title'] && (
                                <div className="venue-item-title">
                                  {venue['title']}
                                </div>
                              )
                            }
                            {
                              ( venue['area'].length > 0 || venue['max_capacity'].length > 0 ) && (
                                <div className="venue-mobile-stats-2">
                                  {
                                    venue['area'].length > 0 && (
                                      <div className="stat-item">
                                        <div className="stat-item-label">
                                          Area:
                                        </div>
                                        <div className="stat-item-value">
                                          {venue['area']}m<sup>2</sup>
                                        </div>
                                      </div>
                                    )
                                  }
                                  {
                                    venue['max_capacity'].length > 0 && (
                                      <div className="stat-item">
                                        <div className="stat-item-label">
                                          Max Capacity:
                                        </div>
                                        <div className="stat-item-value">
                                          {venue['max_capacity']}
                                        </div>
                                      </div>
                                    )
                                  }
                                </div>
                              )
                            }
                            <div className="venue-desktop-stats">
                              {
                                venue['area'].length > 0 && (
                                  <div className="stat-item">
                                    <div className="stat-item-label">
                                      Area:
                                    </div>
                                    <div className="stat-item-value">
                                      {venue['area']}m<sup>2</sup>
                                    </div>
                                  </div>
                                )
                              }
                              {
                                venue['max_capacity'].length > 0 && (
                                  <div className="stat-item">
                                    <div className="stat-item-label">
                                      Max Capacity:
                                    </div>
                                    <div className="stat-item-value">
                                      {venue['max_capacity']}
                                    </div>
                                  </div>
                                )
                              }
                              {
                                venue['classroom_capacity'].length > 0 && (
                                  <div className="stat-item">
                                    <div className="stat-item-icon" dangerouslySetInnerHTML={{__html: window.IndCollStandalone['assets']['chair']}} />
                                    <div className="stat-item-value">
                                      {venue['classroom_capacity']}
                                    </div>
                                  </div>
                                )
                              }
                              {
                                venue['cocktail_capacity'].length > 0 && (
                                  <div className="stat-item">
                                    <div className="stat-item-icon" dangerouslySetInnerHTML={{__html: window.IndCollStandalone['assets']['man']}} />
                                    <div className="stat-item-value">
                                      {venue['cocktail_capacity']}
                                    </div>
                                  </div>
                                )
                              }
                            </div>
                            {
                              venue['description'].length > 0 && (
                                <div className="venue-item-description" dangerouslySetInnerHTML={{__html: venue['description']}} />
                              )
                            }
                            {
                              venue['price'].length > 0 && (
                                <div className="venue-item-price">
                                  {venue['price']}
                                </div>
                              )
                            }
                          </div>
                        </a>
                      </div>
                    );
                  })
                }
              </Fragment>
            ) : (
              <Fragment>
                <div className="capacities-type-content">
                  <div className="table-responsive">
                    <table className="table table-brand">
                      <thead>
                        <tr className="text-capitalize">
                          <th>Room/space</th>
                          <th>Area</th>
                          <th>Ceiling height</th>
                          <th>Capacity</th>
                          <th>Banquet</th>
                          <th>Theatre</th>
                          <th>Classroom</th>
                          <th>U-shape</th>
                          <th>Boardroom</th>
                          <th>Cocktail</th>
                          <th>Cabaret</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="no-border">
                          <td></td>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td><img className="capacity-icons" loading="lazy" src={window.IndCollStandalone['assetsPath'] + 'images/icons/capacity/banquet.svg'}/></td>
                          <td><img className="capacity-icons" loading="lazy" src={window.IndCollStandalone['assetsPath'] + 'images/icons/capacity/theatre.svg'}/></td>
                          <td><img className="capacity-icons" loading="lazy" src={window.IndCollStandalone['assetsPath'] + 'images/icons/capacity/classroom.svg'}/></td>
                          <td><img className="capacity-icons" loading="lazy" src={window.IndCollStandalone['assetsPath'] + 'images/icons/capacity/u-shape.svg'}/></td>
                          <td><img className="capacity-icons" loading="lazy" src={window.IndCollStandalone['assetsPath'] + 'images/icons/capacity/boardroom.svg'}/></td>
                          <td><img className="capacity-icons" loading="lazy" src={window.IndCollStandalone['assetsPath'] + 'images/icons/capacity/cocktail.svg'}/></td>
                          <td><img className="capacity-icons" loading="lazy" src={window.IndCollStandalone['assetsPath'] + 'images/icons/capacity/cabaret.svg'}/></td>
                        </tr>
                        {
                          allVenues.map((venue, i) => {
                            return (
                              <tr key={i}>
                                <td>
                                  <a href={venue['link']}>
                                    <div className="room-space-wrapper">
                                      {
                                        venue['image'].length > 0 && (
                                          <div className="table-item-image-wrapper">
                                            <img src={venue['image']}
                                                className="table-item-image"
                                                loading="lazy"
                                                decoding="async"
                                                alt=""
                                            />
                                          </div>
                                        )
                                      }

                                      {
                                        venue['title'] && (
                                          <div className="table-item-title">
                                            {venue['title']}
                                          </div>
                                        )
                                      }
                                    </div>
                                  </a>
                                </td>
                                <td>
                                  {
                                    venue['area'].length > 0 ? (
                                      <span>{venue['area']}&nbsp;m<sup>2</sup></span>
                                    ) : <span>N/A</span>
                                  }
                                </td>
                                <td>
                                  {
                                    venue['ceiling_height'].length > 0 ? (
                                      <span>{venue['ceiling_height']}&nbsp;m</span>
                                    ) : <span>N/A</span>
                                  }
                                </td>
                                <td>
                                  {
                                    <span>{venue['max_capacity'].length > 0 ? venue['max_capacity'] : 'N/A'}</span>
                                  }
                                </td>
                                <td>
                                  {
                                    <span>{venue['banquet_capacity'].length > 0 ? venue['banquet_capacity'] : 'N/A'}</span>
                                  }
                                </td>
                                <td>
                                  {
                                    <span>{venue['theatre_capacity'].length > 0 ? venue['theatre_capacity'] : 'N/A'}</span>
                                  }
                                </td>
                                <td>
                                  {
                                    <span>{venue['classroom_capacity'].length > 0 ? venue['classroom_capacity'] : 'N/A'}</span>
                                  }
                                </td>
                                <td>
                                  {
                                    <span>{venue['u_shape_capacity'].length > 0 ? venue['u_shape_capacity'] : 'N/A'}</span>
                                  }
                                </td>
                                <td>
                                  {
                                    <span>{venue['boardroom_capacity'].length > 0 ? venue['boardroom_capacity'] : 'N/A'}</span>
                                  }
                                </td>
                                <td>
                                  {
                                    <span>{venue['cocktail_capacity'].length > 0 ? venue['cocktail_capacity'] : 'N/A'}</span>
                                  }
                                </td>
                                <td>
                                  {
                                    <span>{venue['cabaret_capacity'].length > 0 ? venue['cabaret_capacity'] : 'N/A'}</span>
                                  }
                                </td>
                              </tr>
                            );
                          })
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </Fragment>
            )
          )
        }
        {
          (!loading && allVenues.length === 0) && (
            <div className="col-span-1 md:col-span-2">
              <h3 className="text-center">No results found</h3>
            </div>
          )
        }
        {
          (loading || loadMoreLoading) && (
            <VenuesSkeleton />
          )
        }
      </div>
    );
  }
}

AppVenues.propTypes = {
  displayType: PropTypes.string,
  venueType: PropTypes.string,
  eventType: PropTypes.string,
  venueIds: PropTypes.string,
  imageType: PropTypes.string,
};

AppVenues.defaultProps = {
  displayType: '',
  venueType: '',
  eventType: '',
  venueIds: '',
  imageType: '',
};

export default {
  init() {
  },
  finalize() {
    // Render results
    const venuesWrapper = $('#venues-wrapper');
    if (venuesWrapper.length) {
      const venuesProps = {...venuesWrapper[0].dataset};

      ReactDOM.render(<AppVenues {...venuesProps} />, venuesWrapper[0]);
    }

    const venuesTypesFilter = $('#venues-types-filter');
    if (venuesTypesFilter.length) {
      venuesTypesFilter.on('select2:select', function () {
        const _this = $(this);
        const selectedVal = _this.val();
        const params = helpers.getParameters();

        if (selectedVal !== '') {
          params['type'] = selectedVal;
        } else {
          delete params['type'];
        }

        // Push params to url
        helpers.pushStateHistory(!$.isEmptyObject(params) ? '?' + $.param(params) : '');

        $(document).trigger(constants.EVENT_VENUES_TYPE_FILTER_CHANGED, [selectedVal]);
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/acf-blocks/venuesResults.js